type DragData<T extends string> = {
  type: T
  id: string
}

/**
 * Creates a type-safe drag data extractor for a given drag type.
 * Replaces duplicated extractTaskDragData / extractSubTaskDragData / extractChecklistItemDragData.
 */
export function createDragExtractor<T extends string>(dragType: T) {
  return (data: Record<string, unknown> | undefined): DragData<T> | null => {
    if (!data) {
      return null
    }

    const { type, id } = data

    if (type === dragType && typeof id === 'string') {
      return { type: dragType, id }
    }

    return null
  }
}
